import { Controller } from 'react-hook-form';
import Checkbox from '../ui/Checkbox';
import FormSection from '../ui/FormSection';

export default function CEUProcessingStatus({ control, userProfile }) {
  const showRID = userProfile?.certifyingBody === 'RID' || userProfile?.hasBothCertifications;
  const showBEI = userProfile?.certifyingBody === 'BEI' || userProfile?.hasBothCertifications;

  return (
    <FormSection
      title="Processing Status"
      description="Track whether your certifying body has received and processed this CEU"
    >
      <div className="bg-gray-50 p-4 rounded-lg space-y-4">
        {showRID && (
          <div>
            <Controller
              name="processingStatus.rid"
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  label="RID has received and applied this CEU"
                />
              )}
            />
            <p className="text-xs text-gray-500 ml-7 mt-1">
              Check this box only if RID has processed and applied this CEU to your certification record
            </p>
          </div>
        )}

        {showBEI && (
          <div>
            <Controller
              name="processingStatus.bei"
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  label="BEI has received and applied this CEU"
                />
              )}
            />
            <p className="text-xs text-gray-500 ml-7 mt-1">
              Check this box only if BEI has processed and applied this CEU to your certification record
            </p>
          </div>
        )}

        {!userProfile?.hasBothCertifications && (
          <p className="text-xs text-gray-500 mt-2">
            CEUs are typically processed within 30-60 days of submission to your certifying body
          </p>
        )}

        {userProfile?.hasBothCertifications && (
          <p className="text-xs text-gray-500 mt-2 italic">
            <strong>Note:</strong> RID and BEI process CEUs separately and at different times. 
            You can check each box independently as they are approved.
          </p>
        )}
      </div>
    </FormSection>
  );
}
